import Enum from "../../../enums/Enum";

const EnumAppointmentSource = new Enum({
    MEDAI: "Med-AI",
    WEBSITE: "Patient Portal",
    CHATBOT: "Chatbot"
});

export default EnumAppointmentSource;